import { useContext } from 'react'
import { ServiceContext } from '@/app/context/DIContext/DIProvider'

export const useDIService = <T>(key: string): T => {
    const service = useContext(ServiceContext)

    if (!service) {
        throw new Error('Service not found in context')
    }
    return service.resolve(key) as T
}
